<template>
  <div class="download-ctn doko-download">
    <p>欢迎下载 豆蔻助手(DokoScript)</p>
    <p>豆蔻助手是一款手机自动化增强工具，帮助您更高效地处理日常任务。</p>
    <div class="download-wrap">
      <a download="doko.apk" target="_blank" href="https://www.haoping.fun/download/doko-v1.1.0.apk">
        <Button type="primary">安卓下载</Button>
      </a>
    </div>
  </div>
  <p style="color: #cccccc; bottom:0; width: 100%;">
    <a style="color: #cccccc;" href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2023043242号-1</a>
  </p>
</template>

<style lang="less">
#app   .doko-download{
  .download-wrap{
    justify-content: center;
  }
}
.download-ctn {
  font-family: Arial, sans-serif;
  text-align: center;
  padding: 20px;
  h1 {
    color: #333;
  }
  p {
    color: #333;
    margin-bottom: 20px;
  }
  .download-button {
    display: inline-block;
    padding: 10px 20px;
    text-decoration: none;
    border-radius: 5px;
    font-weight: bold;
  }
  a {
    color: inherit;
  }
}
</style>

<script>
import { Button } from "vant";
import { ref, onMounted } from "vue";
import API from "@/api";
import { getUrlParam } from "@/utils/util";

export default {
  name: "DokoDownload",
  components: { Button },
  setup() {
    let shareToken = getUrlParam("share_token");

    if (shareToken) {
      localStorage.setItem("shareToken", shareToken);
    } else {
      shareToken = localStorage.getItem("shareToken");
    }

    onMounted(() => {
      if (!shareToken) {
        return;
      }

      const key = "download_send_flag";
      const downloadSendFlag = localStorage.getItem(key);
      if (!downloadSendFlag) {
        API.share.downloadRecord(shareToken).then((res) => {
          if (res.success) {
            localStorage.setItem(key, shareToken);
          }
        });
      }
    });

    return {};
  },
};
</script>
